var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-locale-provider", { attrs: { locale: _vm.locale } }, [
    _c("div", [
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("div", { style: { borderBottom: "1px solid #E9E9E9" } }, [
        _c("h3", [_vm._v("设备列表")])
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("a-table", {
            attrs: {
              rowSelection: _vm.rowSelection,
              columns: _vm.columns,
              dataSource: _vm.result
            },
            scopedSlots: _vm._u([
              {
                key: "onlineStatus",
                fn: function(text, record) {
                  return _c("span", {}, [
                    record.onlineStatus == 0
                      ? _c("span", [_vm._v("离线")])
                      : _vm._e(),
                    _vm._v(" "),
                    record.onlineStatus == 1
                      ? _c("span", [_vm._v("在线")])
                      : _vm._e()
                  ])
                }
              }
            ])
          }),
          _c("br"),
          _vm._v(" "),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { "a-col": "", span: "24", align: "right" } },
                [
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-right": "5vw" },
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.addDevice()
                        }
                      }
                    },
                    [_vm._v("同步设备")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-modal",
                    {
                      attrs: { title: "提示", locale: "{locale}" },
                      on: { ok: _vm.handleOk },
                      model: {
                        value: _vm.visible,
                        callback: function($$v) {
                          _vm.visible = $$v
                        },
                        expression: "visible"
                      }
                    },
                    [_c("p", [_vm._v("同步完成，点击确定关闭页面")])]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }